<div class="table-responsive gung-responsive">
  <table class="table table-borderless table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" translate>RETURN_ORDER_ID</th>
        <th scope="col" translate>CUSTOMER</th>
        <th scope="col" translate>RETURN_DATE</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let returnOrder of data">
        <td [attr.data-label]="'RETURN_ORDER_ID' | translate">{{ returnOrder.id }}</td>
        <td [attr.data-label]="'CUSTOMER' | translate">{{ returnOrder.customerId }}</td>
        <td [attr.data-label]="'RETURN_DATE' | translate">
          <span *ngIf="returnOrder.returnDate">
            {{ returnOrder.returnDate | date: dateUtilService.dateFormat }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
